module.exports = __webpack_public_path__ + "img/login.5e03c171.png";